import { applySnapshot, Instance, SnapshotOut, types } from "mobx-state-tree"

export const UserModel = types
  .model("User")
  .props({
    isLoggedIn: types.optional(types.boolean, false),
    memberCode: types.maybeNull(types.string),
    fullName: types.maybeNull(types.string),
    id: types.maybeNull(types.string || types.number),
    accessToken: types.maybeNull(types.string),
    role: types.maybeNull(types.string),
    profileImage: types.maybeNull(types.string),
    language: types.optional(types.string, "en"),
    totalPoint: types.maybeNull(types.number),
    real_member_code: types.maybeNull(types.string),
    referral_code: types.maybeNull(types.string),
    savedMe: types.maybeNull(types.boolean),
    savedPhoneNum: types.maybeNull(types.string),
    savedPinNum: types.maybeNull(types.string),
    flagInfo: types.optional(
      types.model({
        callingCode: types.string,
        cca2: types.string,
        flag: types.string,
      }),
      {
        callingCode: "+60",
        cca2: "MY",
        flag: "MY",
      },
    ),
    hidePromotion: types.maybeNull(types.number),
  })
  .actions((self) => ({
    update: (data) => {
      self = Object.assign(self, data)
    },
  }))
  .actions((self) => ({
    updateLanguage: (language: string) => {
      self.language = language
    },
    updateIsLoggedIn: (status: boolean) => {
      self.isLoggedIn = status
    },
    setFlagInfo(flagData: any) {
      self.flagInfo = flagData
    },
    logout: () => {
      applySnapshot(self, {})
    },
    resetAuthData() {
      self.memberCode = null
      self.fullName = null
      self.id = null
      self.role = null
      self.language = "en"
      self.accessToken = null
      self.isLoggedIn = false
      self.totalPoint = 0
      self.profileImage = null
      self.hidePromotion = 0
    },
  }))
  .views((self) => ({
    get isSignedIn() {
      return !!self.accessToken
    },

    get currentLanguage() {
      return self.language
    },
  }))

/* eslint-enable no-param-reassign */
type UserType = Instance<typeof UserModel>
export interface Auth extends UserType {}
type UserSnapshotType = SnapshotOut<typeof UserModel>
export interface UserSnapshot extends UserSnapshotType {}
